import { Swoosh } from "@/components/Brand";

const ITEMS = [
  "PREMIUM AIRCRAFT DETAILING",
  "EXTERIOR & INTERIOR",
  "CERAMIC PROTECTION",
  "BRIGHTWORK POLISH",
  "AVIATION-GRADE CARE",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section className="border-y border-white/10 bg-ink py-6 overflow-hidden" data-testid="marquee">
      <div className="marquee-track">
        {row.map((t, i) => (
          <div key={i} className="flex items-center gap-8 pr-8">
            <span className="font-mono text-sm uppercase tracking-[0.24em] text-white/70">{t}</span>
            <Swoosh className="w-8 h-5 text-lime shrink-0" />
          </div>
        ))}
      </div>
    </section>
  );
}
